import React from 'react';
import styled from 'styled-components';

const StyledImage = styled.img`
  margin-right: 5px;
  margin-bottom: 5px;
`;

const NavLogo = () => {

  return (
    <StyledImage src='/logo/logo_s.png' alt='logo' height={26}/>
  );
};

export {
  NavLogo,
};